import React from 'react'
import ListPage from '../../Components/List/ListPage'
import DropdownGroup from '../../Components/Dropdown/DropdownGroup'
import DropdownItem from '../../Components/Dropdown/DropdownItem'
import {ColInfo, ColOptions, ColSelect,} from '../../Components/List/Col'
import Dropdown from '../../Components/Dropdown'
import {ButtonIcon} from '../../Components/Button/Button'
import styles from '../../../CSS/main.css'
import URLItem, {URL} from '../../Components/List/Item/URLItem'
import {useNavigation} from '../../utils/navigation'
import {useListState} from '../../Components/List/hooks'
import {INIT_URL_STATE, URL_FILTERS, URL_STATE} from './filters'
import {Filters} from '../../Components/Filters'
import {getUrls, enableUrlSetting, disableUrlSetting} from "../../api/requests";

const URLs: React.VFC = () => {
  const { goBack, goToNewTab } = useNavigation()

  const {
    params,
    setActiveTab,
    onPageChange,
    select,
    selectedItems,
    onChangeSearch,
    setListParams,
    resetState,
    items,
    pageCount,
    loading,
  } = useListState<URL, URL_STATE>(INIT_URL_STATE, getUrls)

  const { page, tab, searchTerm } = params

  const enableUrl = async (url: string) => {
    await enableUrlSetting(url)
    onPageChange(page)
  }

  const disableUrl = async (url: string) => {
    await disableUrlSetting(url)
    onPageChange(page)
  }

  return (
    <ListPage
      loading={loading}
      items={items}
      searchTerm={searchTerm}
      onChangeSearch={onChangeSearch}
      filters={(toggle) => (
        <Filters
          filters={URL_FILTERS}
          filterState={params}
          updateParams={setListParams}
          onReset={resetState}
          onClose={toggle}
        />
      )}
      itemRenderer={(i) => (
        <URLItem
          key={i.name}
          onSelected={() => select(i)}
          selected={selectedItems.includes(i)}
          url={i}
          options={
            <>
              <DropdownGroup>
                <DropdownItem onClick={()=> goToNewTab(i.name)}>Go to URL</DropdownItem>
              </DropdownGroup>
              <DropdownGroup>
                <DropdownItem onClick={()=> enableUrl(i.name)}>Enable URL</DropdownItem>
                <DropdownItem onClick={()=> disableUrl(i.name)}>Disable URL</DropdownItem>
              </DropdownGroup>
            </>
          }
        />
      )}
      headerRenderer={() => (
        <>
          <ColInfo>
            <a href='#'>URL</a>
          </ColInfo>
          <ColOptions />
        </>
      )}
      title={'Manage URLs'}
      onBack={goBack}
      tabs={[]}
      activeTab={tab}
      onChangeTab={setActiveTab}
      pageCount={pageCount}
      page={page}
      onPageChange={onPageChange}
    />
  )
}

export default URLs
